import React, { useState } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  InputWrapper,
  ErrorShow,
} from "./style";
import { toast } from "react-toastify";
import { authHeader } from "../helper/authHeader";
import logoImg from "../assets/logo/Logo.png";

const ChangePassword = ({ isOpen, onClose, userProfile }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.currentPassword)
      newErrors.currentPassword = "Current password is required.";
    if (!formData.password) newErrors.password = "New password is required.";
    else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }
    return newErrors;
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/change-password`,
        {
          method: "PUT",
          headers: authHeader(true),
          body: JSON.stringify({
            current_password: formData.currentPassword,
            new_password: formData.password,
            new_password_confirmation: formData.confirmPassword,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("authToken", JSON.stringify(data.token));
        toast.success("Password reset successful");
        onClose(); // Close modal on success
      } else {
        toast.error(data.message || "An error occurred.");
      }
    } catch (error) {
      toast.error("Error while changing the password.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Form onSubmit={handlePasswordChange}>
          <Title>
            <img width={200} src={logoImg} alt="logo" />
          </Title>

          <InputWrapper>
            <Input
              type="password"
              name="currentPassword"
              value={formData.currentPassword}
              onChange={handleInputChange}
              placeholder="Enter Current password"
              required
            />
            {errors.currentPassword && (
              <ErrorShow>{errors.currentPassword}</ErrorShow>
            )}
          </InputWrapper>

          <InputWrapper>
            <Input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter new password"
              required
            />
            {errors.password && <ErrorShow>{errors.password}</ErrorShow>}
          </InputWrapper>

          <InputWrapper>
            <Input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              placeholder="Confirm new password"
              required
            />
            {errors.confirmPassword && (
              <ErrorShow>{errors.confirmPassword}</ErrorShow>
            )}
          </InputWrapper>

          <Button type="submit">Change Password</Button>
        </Form>
      </ModalContent>
    </>
  );
};

export default ChangePassword;
